import { combineReducers } from "redux";
import mainReducer from "./reducer/mainReducer";
const rootReducer = combineReducers({
 mainReducer
});
export default rootReducer;
